import * as React from "react";
export function UitkLayout({
  children,
  className,
  tag,
  style,
  ...attributes
}) {
  const Tag = tag ?? "div";
  return children ? /* @__PURE__ */ React.createElement(Tag, { className, style, ...attributes }, children) : null;
}
